// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { styled } from '@mui/material';
import { LinkComponent, createLink } from '@tanstack/react-router';

const HorizontalNavigationAnchor = styled('a')(({ theme }) => ({
  whiteSpace: 'nowrap',
  textDecoration: 'none',
  justifyContent: 'start',
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  marginRight: theme.spacing(2),
  color: theme.palette.text.secondary,
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  transition: theme.transitions.create(['color']),
  borderBottom: '2px solid transparent',
  '&.active': {
    borderBottomColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

const Link = createLink(HorizontalNavigationAnchor);

/**
 * A styled link component for navigating within the application. This
 * component is intended to be used in a horizontal tab-style navigation.
 */
export const HorizontalNavigationLink: LinkComponent<
  typeof HorizontalNavigationAnchor
> = (props) => {
  return <Link preload="intent" {...props} />;
};
